<div class='goal-display'>
  <h1 class='goal-display-name'>{{goalCategory.name}}</h1>
  <div *ngIf='!loadingGoals && !loadingGoalsError; else showLoader'>
    <div class='user-goals'>
      <div *ngFor='let goal of goals'>

      <!--<div class='mat-elevation-z1 goal-wrapper' *ngFor='let goal of goals'>-->
        <p class='user-goal-title'>{{goal.description}}</p>
        <section class="goal-step" *ngFor='let step of goal.steps'>
          <app-goal-step-display [step]='step' [goal]='goal' (toggleGoalStatus)="toggleStatus($event, goal)" [loading]='addingGoalStep' [eventTransmitter]='eventTransmitter'></app-goal-step-display>
        </section>
        <form [formGroup]='stepForm'>
          <mat-form-field  appearance='outline'>
            <mat-label>What action is needed to complete this goal?</mat-label>
            <input autocomplete="off" matInput placeholder="What action is needed to complete this goal?" formControlName='description'>
          </mat-form-field>
          <div class="end-button">
            <button mat-raised-button color='primary' (click)="addGoalStep(goal)" [disabled]='disabledAddStepButton'>Add Step</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div>
    <!-- form to add a new step -->
    <form [formGroup]='goalForm' class="user-goals">
      <mat-form-field  appearance='outline'>
        <mat-label>Add a new Goal?</mat-label>
        <input autocomplete="off" matInput placeholder="What action is needed to complete this goal?" formControlName='description'>
      </mat-form-field>
      <div fxLayout='row' fxLayoutAlign='end center'>
        <button mat-raised-button color='primary' (click)="addGoal()" [disabled]='disabledAddGoalButton'>Add Goal</button>
      </div>
    </form>
  </div>

  <ng-template #showLoader>
   <div class="spinner" *ngIf='loadingGoals'>
     <mat-spinner></mat-spinner>
     <p>Loading goals</p>
   </div>

   <div class="error-loading" *ngIf='loadingGoalsError'>
     Error: {{loadingGoalsError}}
   </div>
  </ng-template>
</div>

